import { Component, type ErrorInfo, type PropsWithChildren } from "react";
import Logger from "@/lib/logger.ts";

type StateType = { hasError: boolean; error: Error | null };

export default class ErrorBoundary extends Component<PropsWithChildren, StateType> {
    constructor(props: PropsWithChildren) {
        super(props);

        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        const { name, message } = error;

        Logger.error(`[${name}] ${message}\n`, errorInfo.componentStack);
    }

    render() {
        const { children } = this.props;
        const { hasError } = this.state;

        return hasError ? null : children;
    }
}
